/*
 * Page Name
 */

(function ($) {

    // your code here, can use with $

})(jQuery);